module.exports = __webpack_public_path__ + "img/bj002.e012e9a1.png";